"use strict";
/**
 * Created by rouven on 22.03.17.
 */
exports.__esModule = true;
exports.LOCATION_CHANGED = exports.EDIT_START = exports.DESTROY_FILTER = exports.INITIALIZE_FILTER = exports.SELECTION_CLEARED = exports.SELECTION_CHANGED = exports.DATA_CHANGED = exports.DESTROY = exports.INITIALIZE = void 0;
var PREFIX = '@@wikom-grid/';
exports.INITIALIZE = PREFIX + 'INITIALIZE';
exports.DESTROY = PREFIX + 'DESTROY';
exports.DATA_CHANGED = PREFIX + 'DATA_CHANGED';
exports.SELECTION_CHANGED = PREFIX + 'SELECTION_CHANGED';
exports.SELECTION_CLEARED = PREFIX + 'SELECTION_CLEARED';
exports.INITIALIZE_FILTER = PREFIX + 'INITIALIZE_FILTER';
exports.DESTROY_FILTER = PREFIX + 'DESTROY_FILTER';
exports.EDIT_START = PREFIX + 'EDIT_START';
exports.LOCATION_CHANGED = PREFIX + 'LOCATION_CHANGED';
